import { render, staticRenderFns } from "./Science-addfication.vue?vue&type=template&id=f67072ee&scoped=true&"
import script from "./Science-addfication.vue?vue&type=script&lang=js&"
export * from "./Science-addfication.vue?vue&type=script&lang=js&"
import style0 from "./Science-addfication.vue?vue&type=style&index=0&id=f67072ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67072ee",
  null
  
)

export default component.exports